<template>
    <div id="app" ref="app">

        <transition
        name="fade"
        @css="false">
            <router-view></router-view>
        </transition>

        <!-- <div class="m" ref="pointerMask" :class="{ 'no-pointer' : !Global.lockScreen }"></div> -->

    </div>
</template> 

<script>

    import Global from '../lib/GlobalState'
    // import Headbar from '../partials/Headbar'
    import Footbar from '../partials/Footbar'
    import { EventBus } from '../event-bus.js';

    export default {

        name: "App",

        components: {
            // Headbar,
            Footbar
        },

        data() {
            return {
                Global,
                // wheelOpt: null,
                // wheelEvent: null,
                // keys: [
                //     { 37: 1 },
                //     { 38: 1 },
                //     { 39: 1 },
                //     { 40: 1 },
                //     { 32: 1 },
                //     { 33: 1 },
                //     { 34: 1 },
                //     { 35: 1 }
                // ]
            }
        },

        beforeMount () {
            window.addEventListener('resize', this.handleResize)
        },

        mounted() {
            this.init()
        },

        methods: {

            init() {
                // this.wheelInit()
                // this.disableScroll()
                this.handleResize()
            },

            handleResize() {
                this.Global.windowWidth = document.documentElement.clientWidth
                this.Global.windowHeight = document.documentElement.clientHeight
                EventBus.$emit('globalResize');
            },

            // preventDefault(event) {
            //     event.preventDefault();
            // },

            // preventDefaultForScrollKeys(event) {
            //     if (this.keys[event.keyCode]) {
            //         preventDefault(event);
            //         return false;
            //     }
            // },

            // wheelInit() {
            //     let supportsPassive = false;
            //     try {
            //     window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            //         get: function () { supportsPassive = true; } 
            //     }));
            //     } catch(e) {}

            //     this.wheelOpt = supportsPassive ? { passive: false } : false;
            //     this.wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
            // },

            // disableScroll() {
            //     console.log('alo?')
            //     window.addEventListener('DOMMouseScroll', this.preventDefault, false)
            //     window.addEventListener(this.wheelEvent, this.preventDefault, this.wheelOpt)
            //     window.addEventListener('touchmove', this.preventDefault, this.wheelOpt)
            //     window.addEventListener('keydown', this.preventDefaultForScrollKeys, false)
            // },

            // enableScroll() {
            //     window.removeEventListener('DOMMouseScroll', this.preventDefault, false)
            //     window.removeEventListener(this.wheelEvent, this.preventDefault, this.wheelOpt) 
            //     window.removeEventListener('touchmove', this.preventDefault, this.wheelOpt)
            //     window.removeEventListener('keydown', this.preventDefaultForScrollKeys, false)
            // }
        
        }

    }

</script>